import { EStationStatus } from '../api/station/types';

export const availableConnectorStatuses = [EStationStatus.AVAILABLE];
export const connectedConnectorStatuses = [EStationStatus.PREPARING];
export const unavailableStationAndConnectorStatuses = [
    EStationStatus.FAULTED,
    EStationStatus.UNAVAILABLE,
];
